import { HereLayer } from 'common/utils/MapMarker/types';
import { useMemo } from 'react';
import { getCarIcon } from 'features/cars/CarEBoxLocations/utils';
import { svgToDataURL } from 'common/utils';
import { getMobileIcon } from '../utils';
import { useGetMyFleet } from './useGetMyFleet';
import { getColorAutoByStatus } from 'shared/utils';
import { getAutoStatusByDate } from 'shared/utils/getAutoStatusByDate';
import { CAR_HEIGHT, CAR_WIDTH } from 'components/Map/constants';
import { useCarOperations } from 'entities/cars';

export const useUserCurrentLocationMarkersLayer = () => {
  const myFleet = useGetMyFleet();
  const { setSelectedCarEBoxLocation } = useCarOperations();

  const data = useMemo(
    () =>
      (myFleet || [])
        .filter(({ deviceType }) => deviceType === 'E100MobileApp')
        .map(({ latitude, longitude, lastActivityDate, ...data }) => {
          return {
            lastActivityDate,
            longitude,
            latitude,
            ...data,
          };
        }),
    [myFleet]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: 'current-location',
      type: 'marker',
      getCoordinates: ({
        data: { longitude, latitude }
      }) => ({
        latitude,
        longitude
      }),
      getIcon: ({ clusterWeight, data }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            width,
            height,
            anchorY: height,
            anchorX: width / 2
          };
        }

        const locationStatusColor = getColorAutoByStatus(
          getAutoStatusByDate(data.lastActivityDate)
        );
        const { url, height, width } = {
          url: svgToDataURL(getMobileIcon(locationStatusColor)),
          width: CAR_WIDTH,
          height: CAR_HEIGHT,
        };

        return {
          url,
          width,
          height,
          anchorY: height,
          anchorX: width / 2
        };
      },
      onClick: ({ data }) => {
        setSelectedCarEBoxLocation(data as any);
      },
    }),
    [data, setSelectedCarEBoxLocation]
  );

  return clientHistoryEventsMarkersLayer;
};
